export const BASE_PUBLIC_V2_PATH = '/v2';
export const BASE_PUBLIC_API_V2_URL = `${process.env.REACT_APP_API_BASE_URL ?? ''}/api/v2`;
export const BASE_PUBLIC_API_ROOT_PATH = `${BASE_PUBLIC_API_V2_URL}/public`;
